export default __webpack_public_path__ + "static/media/blank.6b9979b2.jpg";